export function getPlayersRanking (players) {
  return [...players].sort((a, b) => b.score - a.score)
}
